import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import Page from 'components/Page';
import AppHeader from 'components/AppHeader';

import './styles.scss';

export default function LeaderBord() {
    const [leaderbord, setLeaderbord] = useState([]);

    useEffect(() => {
        const options = { method: 'GET', url: `${process.env.REACT_APP_API_URL}/score` };
        axios.request(options).then(function (response) {
            setLeaderbord(response.data.score)
        }).catch(function (error) {
            console.error(error);
        });
        return () => { }
    }, []);

    return (
        <>
            <AppHeader />
            <Page>
                <div className="content">
                    {leaderbord ?

                        (<div className="scrollable">
                            <table className='scores_table'>
                                {leaderbord.map((score, index) => (
                                    <tbody key={score.id}>
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{score.pseudo}</td>
                                            <td>{score.score}</td>
                                        </tr>
                                    </tbody>
                                ))}
                            </table>
                        </div>)

                        : null

                    }
                    <Link to={'/'}>
                        <div className="button" >Accueil</div>
                    </Link>
                </div>
            </Page>
        </>
    );
}